import theme from '../../themes/pTheme/pTheme'

export const handleClickChartOutside = (chart) => {
  const {draw} = chart.marker
  if (!draw && (chart.options.plugins.marker.enabled || chart.options.plugins.marker.editEnabled)) {
    chart.options.plugins.marker.enabled = false
    if (chart.options.plugins.marker.editEnabled) {
      changeLabelColorOnEditToggle(chart, theme.palette.hpBaseDark)
      chart.options.plugins.marker.editEnabled = false
    }
    chart.setIsAnyModeEnabled(false)
    chart.update()
  }
  updateMouseListners(chart)
}
export const updateMouseListners = (chart) => {
  if (chart.position) {
    chart.position = null
    chart.tooltip._active = []
    chart.tooltip.update(true)
    chart.options.plugins.tooltip.events = ['mousemove', 'mouseout', 'touchstart', 'touchmove', 'touchend']
    chart.update()
  }
}
export const changeLabelColorOnEditToggle = (chart, color) => {
  for (const key in chart.options.plugins.annotation.annotations) {
    chart.options.plugins.annotation.annotations[key].label.backgroundColor = color
  }
}

export const handleClickAddMarker = (chart, setClickAwayEnabled) => {
  if (chart) {
    if (chart.options.plugins.marker.enabled) {
      chart.options.plugins.marker.enabled = false
      chart.setIsAnyModeEnabled(false)
      setClickAwayEnabled(false)
    } else {
      chart.options.plugins.marker.enabled = true
      chart.setIsAnyModeEnabled(true)
      if (chart.options.plugins.marker.editEnabled) {
        changeLabelColorOnEditToggle(chart, theme.palette.hpBaseDark)
        chart.options.plugins.marker.editEnabled = false
      }
      setClickAwayEnabled(true)
    }

    chart.update()
  }
}

export const handleClickEditMarker = (chart, setClickAwayEnabled) => {
  if (chart) {
    if (chart.options.plugins.marker.editEnabled) {
      chart.options.plugins.marker.editEnabled = false
      changeLabelColorOnEditToggle(chart, theme.palette.hpBaseDark)
      chart.setIsAnyModeEnabled(false)
      setClickAwayEnabled(false)
    } else {
      chart.options.plugins.marker.editEnabled = true

      chart.options.plugins.marker.enabled = false
      changeLabelColorOnEditToggle(chart, theme.palette.hpPrimary)
      chart.setIsAnyModeEnabled(true)
      setClickAwayEnabled(true)
    }

    chart.update()
  }
}

/* Function Descriptions:
  - handleClickChartOutside: Disables marker modes and updates chart state when clicking outside the chart.
  - updateMouseListners: Resets chart position, tooltip, and mouse event listeners.
  - changeLabelColorOnEditToggle: Updates annotation label background color on edit toggle.
  - handleClickAddMarker: Toggles marker mode and updates chart state for adding markers.
  - handleClickEditMarker: Toggles edit mode and updates chart state for editing markers.
*/
